import React from "react";
import RaindropCopyable from "../raindrop-copyable/raindrop-copyable.tsx";

const Currency = ({
  subunits = 1000,
  currency = "GBP",
  isMonthly = false,
  isStylised = false,
  isShowingDecimals = true,
  isShowingCurrencySymbol = true,
  isShowingCurrency = true,
  isShowingValue = true,
  isCopyable = false,
}) => {
  const prefix = {
    GBP: "£",
    USD: "$",
    EUR: "€",
    NZD: "$",
  }[currency];

  let amount = subunits / 100;

  let fractionDigits = 2;
  if (!isShowingDecimals) {
    fractionDigits = 0;
  }

  let amountString = amount.toLocaleString("en-GB", {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
    compactDisplay: "short",
  });

  let additionalText = "";

  if (isMonthly) {
    additionalText = "/month";
  }

  const suffix = currency;

  let amountSize = "text-md";
  let font = "font-normal";
  let textSize = "text-md";

  if (isStylised) {
    amountSize = "text-xl";
    textSize = "text-sm";
    font = "font-bold";
  }

  return (
    <RaindropCopyable text={amountString} isCopyable={isCopyable}>
      <div className={`flex flex-row items-baseline ${font} ${textSize} `}>
        {isShowingCurrencySymbol && <div>{prefix}</div>}
        {isShowingValue && (
          <div className={`${amountSize}`}>{amountString}</div>
        )}
        {isShowingCurrency && <div className={"ml-1"}>{suffix}</div>}
        <div>{additionalText}</div>
      </div>
    </RaindropCopyable>
  );
};

export default Currency;
